let adyenRedirectionHandled = false;
const handleAdyenRedirection = (
  t,
  searchParams,
  onShowMessage,
  onSuccess,
  scrollElement
) => {
  const resultCode = searchParams.get('resultCode');
  if (resultCode && !adyenRedirectionHandled) {
    adyenRedirectionHandled = true;
    setTimeout(() => {
      scrollElement.focus({ preventScroll: true });
      scrollElement.scrollIntoView({
        block: 'center',
        behaivor: 'smooth',
      });
    }, 10);

    switch (resultCode) {
      case 'cancelled':
        onShowMessage(t('Payment was cancelled'), 'danger');
        break;
      case 'authorised':
        const orderReference = searchParams.get('orderRef');
        const redirectResult = searchParams.get('redirectResult');
        const shopperReference = searchParams.get('shopperRef');
        onSuccess({ orderReference, shopperReference, redirectResult });
        break;
      case 'received':
      case 'refused':
      default:
        onShowMessage(
          'Failure authorizing your payment. Please try again.',
          'danger'
        );
        break;
    }
    searchParams.delete('resultCode');
    searchParams.delete('orderRef');
    searchParams.delete('shopperRef');
  }
};

export default handleAdyenRedirection;
